/* unplugin-vue-components disabled */
import SendButton from './send-button.vue'

export default {
  components: {SendButton},
  mixins: [ModelValue(String)],
  props: {
    placeholder: {type: String, default: 'Ask..'},
    description: {type: String, default: ''},
    generating: {type: Boolean, default: false},
    controls: {type: Boolean, default: false},
    canPush: {type: Boolean, default: false}
  },
  emits: ['focusin', 'focusout', 'push', 'stop'],
  data() {
    return {
      rows: 1
    }
  },
  watch: {
    async value() {
      this.rows = 1
      this.$nextTick(this.updateRows)
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    updateRows() {
      const input = this.$refs.input
      if (input.clientHeight < input.scrollHeight && this.rows < 3) {
        this.rows += 1
        this.$nextTick(this.updateRows)
      }
    },
    blur() {
      this.$refs.input.blur()
    },
    onKeyEnter(ev){
      if (ev.shiftKey) return
      ev.preventDefault()
      this.$emit('push', ev)
    },
  }
}
